import React, {CSSProperties, FunctionComponent} from "react";
import {Box} from "@material-ui/core";
import CheckBox from "./CheckBox";
import CommonTextField from "./ValidateTextInput";

type UncertainInputProps = {
    textInputLabel: string;
    textInputValue: string;
    inputDisabled?: boolean;
    onChangeText: (text: string) => void
    style?: CSSProperties
    checkBoxLabel: string;
    onCheckBoxClick?: () => void
    checkboxChecked?: boolean
    validators?: any[];
    errorMessages?: string[];
    validatorListener?: (isValid: boolean) => void | undefined;
};

const UncertainInput: FunctionComponent<UncertainInputProps> = (props) => (
    <Box style={props.style}>
        <CommonTextField
            label={props.textInputLabel}
            value={props.textInputValue}
            disabled={props.inputDisabled}
            onChangeText={props.onChangeText}
            style={{display: "flex", flexDirection: "column", width: 260, marginBottom: 20}}
        />
        <CheckBox
            text={props.checkBoxLabel}
            checked={props.checkboxChecked}
            onClick={props.onCheckBoxClick}
        />
    </Box>
);


export default UncertainInput;
